'use strict';

var _regeneratorRuntime = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _objectSpread = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread2");

var _asyncToGenerator = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var cid = require('multiformats/cid');

var configure = require('../lib/configure.js');

var toUrlSearchParams = require('../lib/to-url-search-params.js');

var createFlush = configure.configure(function (api) {
  function flush(_x) {
    return _flush.apply(this, arguments);
  }

  function _flush() {
    _flush = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
      var options,
          res,
          data,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

              if (!(!path || typeof path !== 'string')) {
                _context.next = 3;
                break;
              }

              throw new Error('ipfs.files.flush requires a path');

            case 3:
              _context.next = 5;
              return api.post('files/flush', {
                signal: options.signal,
                searchParams: toUrlSearchParams.toUrlSearchParams(_objectSpread({
                  arg: path
                }, options)),
                headers: options.headers
              });

            case 5:
              res = _context.sent;
              _context.next = 8;
              return res.json();

            case 8:
              data = _context.sent;
              return _context.abrupt("return", cid.CID.parse(data.Cid));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _flush.apply(this, arguments);
  }

  return flush;
});
exports.createFlush = createFlush;